import { render, staticRenderFns } from "./CoreLightTrapSchedule.vue?vue&type=template&id=463f881d&"
import script from "./CoreLightTrapSchedule.vue?vue&type=script&lang=js&"
export * from "./CoreLightTrapSchedule.vue?vue&type=script&lang=js&"
import style0 from "./CoreLightTrapSchedule.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports